import { render } from "./TreasuryShopBlock.vue?vue&type=template&id=6dda4ee3&scoped=true"
import script from "./TreasuryShopBlock.vue?vue&type=script&lang=js"
export * from "./TreasuryShopBlock.vue?vue&type=script&lang=js"

import "./TreasuryShopBlock.vue?vue&type=style&index=0&id=6dda4ee3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dda4ee3"]])

export default __exports__